import { Auth0SdkServiceModule } from 'services/auth/auth0sdk.service';
import angularJwt from 'angular-jwt';

import { AUTH0_TENANT_CLAIM } from 'app/constants';

export const AuthTokenServiceModule = angular
    .module('app.services.auth.authTokenService', [
        Auth0SdkServiceModule,
        angularJwt
    ]).factory('authTokenService', (auth0SdkService, $q) => {
        let cachedToken;
        let cachedTenant;

        return {
            getTenantId,
            getBearer,
            getDecodedIdToken,
            getAccessToken,
            getEmail,
            getHeaders,
            getUser,
            getCachedTenantId,
            getCachedToken
        };

        function getCachedTenantId() {
            return cachedTenant;
        }

        function getCachedToken() {
            return cachedToken;
        }

        function getTenantId() {
            return auth0SdkService.getUser().then((user) => {
                return user && (user[AUTH0_TENANT_CLAIM] || user.tenant);
            });
        }

        function getUser() {
            return auth0SdkService.getUser().then((user) => {
                if (user) {
                    cachedTenant = user[AUTH0_TENANT_CLAIM] || user.tenant;
                }
                return user;
            });
        }

        function getEmail() {
            return auth0SdkService.getUser().then((user) => {
                return user && user.email;
            });
        }

        function getAccessToken() {
            return auth0SdkService.getTokenSilently().then((token) => {
                cachedToken = token;

                if (!cachedTenant) {
                    auth0SdkService.getUser().then((user) => {
                        if (user) {
                            cachedTenant = user[AUTH0_TENANT_CLAIM] || user.tenant;
                        }
                    });
                }
                return token;
            });
        }

        function getDecodedIdToken() {
            return auth0SdkService.getUser();
        }

        function getBearer() {
            return getAccessToken();
        }

        function getHeaders() {
            const tokenPromise = getBearer();
            const tenantIdPromise = getTenantId();
            return $q.all([tokenPromise, tenantIdPromise]).then(([token, tenantId]) => {
                return { token, tenantId };
            });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/auth/authToken.service.js